module.exports = __webpack_public_path__ + "img/stamp-insect-aug.a04f78af.png";